module.exports = {
    "crude": {
        "search": "Szukaj",
        "actions": "Akcje",
        "nextPage": "Następna strona",
        "lastPage": "Poprzednia strona",
        "back": "Powrót",
        "empty": "Pusty",
        "edit": "Edycja",
        "create": "Tworzenie",
        "data": "Dane",
        "view": "Pokaż",
        "delete": "Usuń",
        "save": "Zapisz",
        "cancel": "Anuluj",
        "noContent": "Brak dostępnych wpisów.",
        "resetFilter": "Zresetuj filtry i zobacz więcej danych!",
        "createOwnTextField": "Utwórz własne pole tekstowe",
        "textFieldName": "Etykieta pola tekstowego",
        "textFieldValue": "Zawartość",
        "insertTextFieldLabel": "Proszę wpisać nazwę pola tekstowego!",
        "deleteTextField": "Usuń pole tekstowe",
        "success": "Zapisywanie powiodło się",
        "invalidDataFields": "Następujące pola danych są nieprawidłowe:  ",
        "entries": "Wpisy",
        "entry": "Wejście",
        "tabDetail": "Detale",
        "entity": "Podmiot",
        "of": "z",
        "uploadNewFile": "Prześlij plik",
        "upload": "Prześlij",
        "confirm": "OK",
        "deleteFileQuestion": "Czy na pewno chcesz usunąć ten plik? ",
        "deleteFileQuestionTitle": "Uwaga!",
        "deleteEntityQuestion": "Czy na pewno chcesz usunąć ten element? ",
        "deleteEntityQuestionTitle": "Uwaga!",
        "errorLargeFileUpload": "Wybrany plik jest za duży!",
        "useCroppedImage": "Użyj wycinka",
        "useOriginalImage": "Użyj oryginalnego obrazu",
        "available": "Dostępny",
        "searchColumn": "Znajdź kolumnę",
        "manageColumns": "Zarządzaj kolumnami",
        "hideColumn": "Ukryj kolumnę",
        "pinToRight": "Przypnij kolumnę po prawej stronie",
        "pinToLeft": "Przypnij kolumnę po lewej stronie",
        "sortAsc": "Sortuj rosnąco",
        "sortDesc": "Sortuj malejąco",
        "hideAll": "Ukryj wszystko",
        "showAll": "Pokaż wszystko",
        "preview": "Podgląd",
        "title": "Tytuł",
        "description": "Opis",
        "tooltip": "Podpowiedź",
        "sort": "Sortuj według",
        "settings": "Ustawienia",
        "incomingReference": "Odniesienie",
        "language": "Język",
        "deleteTabQuestionTitle": "Uwaga!",
        "deleteTabQuestion": "Czy na pewno chcesz usunąć tę kartę? ",
        "deleteElementQuestionTitle": "Uwaga!",
        "deleteElementQuestion": "Czy na pewno chcesz usunąć ten element? ",
        "configurationEditorDescriptionStringLayout": "W tej kolumnie można wybrać trzy warianty wprowadzenia tekstu:",
        "configurationEditorDescriptionEnumLayout": "W tej kolumnie można wybrać dwa warianty selekcji elementów:",
        "configurationEditorDescriptionBooleanLayout": "W tej kolumnie można wybrać dwa warianty selekcji elementów:",
        "configurationEditorDescriptionForeignEntityLayout": "W tej kolumnie można wybrać dwa warianty selekcji elementów:",
        "stringLayoutsingleline": "Linia pojedyńcza",
        "stringLayoutmultiline": "Multilinia",
        "stringLayouteditor": "Edytor tekstu",
        "enumLayoutradio": "Przełącznik opcji",
        "enumLayoutdropdown": "Dropdown",
        "booleanLayoutcheckbox": "Pole wyboru opcji",
        "booleanLayoutswitch": "Przełącznik",
        "foreignEntityLayoutpopUp": "Okno pop-up",
        "foreignEntityLayoutautocomplete": "Dropdown",
        "foreignEntityLayoutlist": "Lista",
        "formatTooltipbold": "Pogrubienie",
        "formatTooltipitalic": "Kursywa",
        "formatTooltipunderline": "Podkreślenie",
        "formatTooltipstrike": "Przekreślenie",
        "formatTooltipclean": "Usuń format",
        "formatTooltipcodeBlock": "Kod",
        "formatTooltipblockquote": "Cytat",
        "formatTooltipcolor": "Kolor czcionki",
        "formatTooltipbackground": "Kolor tła",
        "formatTooltipfont": "Czcionka",
        "formatTooltipalign": "Wyrównanie",
        "formatTooltipheader": "Rozmiar czcionki",
        "formatTooltipsuper": "Napisany u góry",
        "formatTooltipsub": "Indeks",
        "formatTooltipordered": "Lista uporządkowana",
        "formatTooltipbullet": "Wyliczenie",
        "true": "Tak",
        "false": "Nie",
        "selectEntity": "Wybierz podmiot",
        "filter": "Filtr",
        "useFilter": "Zastosuj filtr",
        "defaultFilter": "Zresetuj filtr",
        "expand": "Zwiększ",
        "hide": "Ukryj",
        "minimumSelectionError": "Należy wybrać co najmniej {{min}} wpisów.",
        "maximumSelectionError": "Można wybrać maksymalnie {{max}} wpisów."
    }
}
;